import React from 'react';
import '../css/Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      © {new Date().getFullYear()} Spaghetti Code Jungle Blog
    </footer>
  );
}